module.exports = __webpack_public_path__ + "img/intro_pc_img03.2129d915.png";